import TWIARepairsOrAdditionsComponent from './components/ConstructionDetails/TWIARepairsOrAdditionsComponent/TWIARepairsOrAdditionsComponent';
import ENTRoofUpdatesComponent from './components/ConstructionDetails/ENTRoofUpdatesComponent/ENTRoofUpdatesComponent';
import StandardizeAddressPopUp from './components/StandardizeAddressPopUp/StandardizeAddressPopUp';
import SuccessPage from './pages/Success/SuccessPage';
import TWIASuccessPage from './pages/TWIASuccessPage/TWIASuccessPage';
import TFPASuccessPage from './pages/TFPASuccessPage/TFPASuccessPage';
import PrintDocumentConfirmationPopup from './pages/PrintDocument/PrintDocumentConfirmationPopup';
import PrintDocumentErrorPopup from './pages/PrintDocument/PrintDocumentErrorPopup';

const entCommonComponentMap = {
    twiaRepairsOrAdditionsComponent: { component: 'TWIARepairsOrAdditionsComponent' },
    entRoofUpdatesComponent: { component: 'ENTRoofUpdatesComponent' },
    standardizeAddressPopUp: { component: 'StandardizeAddressPopUp' },
    printDocumentConfirmationPopup: {component: 'PrintDocumentConfirmationPopup'},
    printDocumentErrorPopup: {component: 'PrintDocumentErrorPopup'}
};

const entCommonComponents = {
    TWIARepairsOrAdditionsComponent,
    ENTRoofUpdatesComponent,
    StandardizeAddressPopUp,
    PrintDocumentConfirmationPopup,
    PrintDocumentErrorPopup
};

export {
    entCommonComponentMap,
    entCommonComponents,
    TWIARepairsOrAdditionsComponent,
    ENTRoofUpdatesComponent,
    StandardizeAddressPopUp,
    SuccessPage,
    TWIASuccessPage,
    TFPASuccessPage,
    PrintDocumentConfirmationPopup,
    PrintDocumentErrorPopup
};
